import { useContext } from "react";
import { DialogContainer } from "@react-spectrum/s2";

import { VideoWizardContext } from "@app/views/projects/videoWizardContext";
import { EditVariationDialog } from "./EditVariationDialog";

/**
 * The `EditVariationDialog` of the variation the wizard is editing
 * (`editVariation`), dismissed by clearing it. Local edits are scoped to
 * the selected project and variation.
 */
export const EditVariationDialogContainer = () => {
  const { video, editVariation, setEditVariation, handleUploadAssets } =
    useContext(VideoWizardContext);

  return (
    <DialogContainer onDismiss={() => setEditVariation(null)}>
      {!!editVariation && (
        <EditVariationDialog
          key={JSON.stringify([video.data?.id, editVariation.key])}
          videoId={video.data?.id}
          variationKey={editVariation.key}
          referenceKey={editVariation.referenceKey}
          isReferenceAsset={!!editVariation.isReferenceAsset}
          dependencies={editVariation.dependencies}
          onUpload={handleUploadAssets}
        />
      )}
    </DialogContainer>
  );
};
